import * as TS from "~/Services/TS";
import { Dictionary } from "~/Types/Common";

declare global {
    namespace translations {
        const setLabels: (labelsByKey: Dictionary<string>, isDebugModeEnabled: boolean) => void;
    }
}

// @ts-ignore
window.translations = window.translations || {};
window.translations = {
    ...window.translations,
    ...TS,
};
